var map = {
	"./black/shipinhuiyi2.png": "hN3E",
	"./blue/shipinhuiyi2.png": "QMiJ",
	"./white/shipinhuiyi2.png": "YZ2B"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "z1ic";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/shipinhuiyi2\.png$
// module id = z1ic
// module chunks = 24